import styled from 'styled-components';

export const ActivityCardContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['blocked', 'isActive'].includes(prop),
})`
  cursor: ${(props) => (props.blocked ? 'default' : 'pointer')};
  width: 100%;
  min-height: 127px;
  padding: 17px 36px 17px 32px;
  background-color: ${(props) =>
    props.isActive ? props.theme.colors.bgSecondary : props.theme.colors.white};
  border-bottom: 0.5px solid #646464;
  display: grid;
  grid-template-columns: 2fr 4fr 2fr 1fr;
  gap: 20px;
  align-items: center;

  .activity-index {
    font-style: normal;
    font-weight: 600;
    font-size: 64px;
  }

  .status {
    color: ${(props) => props.theme.colors.successMessage};
    svg {
      fill: none;
      stroke: ${(props) => props.theme.colors.successMessage};
    }
  }

  button {
    margin-left: auto;
  }

  .description {
    grid-column: 1 / span 4;
  }

  @media ${(props) => props.theme.device.mobileL} {
    padding: 24px 16px;
    grid-template-columns: 1fr 6fr 1fr;
    column-gap: 16px;

    .activity-index {
      font-size: 48px;
      line-height: 48px;
      align-self: start;
    }

    .status {
      grid-row-start: 2;
      grid-column-start: 2;
    }
    .description {
      grid-column: 1 / span 3;
    }
  }
`;

export const ContentWrapper = styled.div`
  grid-column: 1 / span 4;

  @media ${(props) => props.theme.device.mobileL} {
    grid-column: 1 / span 3;
  }
`;
